import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  Button,
  Card,
  FlatActionList,
  Page,
  Stack,
} from "@towersystems/roam-common-native";
import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import React, { useCallback } from "react";
import { SetupNative2faRootParamList } from "../../../../types";
import { MfaCodeStrategy } from "@towersystems/roam-common/lib/generated-types";
import { useFocusEffect } from "@react-navigation/native";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { FlatListSearchableSkeleton } from "../../../../components/FlatListSearchableSkeleton";
import { useTranslation } from "../../../../utilities/i18n";

export type ListNative2faMethodsScreenProps = NativeStackScreenProps<
  SetupNative2faRootParamList,
  "ListNative2faMethodsScreen"
>;

export const ListNative2faMethodsScreen = ({
  navigation,
}: ListNative2faMethodsScreenProps) => {
  const { t } = useTranslation("settings");
  const [loading, setLoading] = React.useState<boolean>(true);
  const { user, me } = useAuthenticationProvider();

  const transitionEnded = useHasTransitionEnded(navigation);

  function navigateToSelectScreen() {
    navigation.navigate("Native2faMethodSelectScreen");
  }

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () => {
        return (
          <Button
            isAction
            size="compact"
            label={t("action.setup_mfa_method.label")}
            onPress={navigateToSelectScreen}
          ></Button>
        );
      },
    });
  }, []);

  useFocusEffect(
    useCallback(() => {
      me().finally(() => {
        setLoading(false);
      });
    }, [])
  );

  if (loading || !transitionEnded) {
    return <FlatListSearchableSkeleton searchbar={false} />;
  }

  if (!user) {
    return null;
  }

  const verifiedMfaMethods = user.mfaMethods.filter((i) => i.verified);

  const activeMfaMethodsMarkup = (
    <Card
      title={
        verifiedMfaMethods?.length
          ? t("card.current_mfa_methods.title")
          : t("card.no_mfa_methods.title")
      }
    >
      <FlatActionList
        items={
          verifiedMfaMethods?.length
            ? verifiedMfaMethods.map((i) => {
                return {
                  key: i.id,
                  title: `Remove ${i.identifier || "******"}`,
                  subTitle: i.strategy,
                  onPress: () =>
                    navigation.navigate("RemoveNative2faRootScreen", {
                      strategy: i.strategy as unknown as MfaCodeStrategy,
                      screen: "RemoveNative2faEnterCredentialsScreen",
                    }),
                  destructive: true,
                };
              })
            : [
                {
                  key: "setup",
                  title: t("action.setup_mfa_method.label"),
                  onPress: navigateToSelectScreen,
                },
              ]
        }
      />
    </Card>
  );

  return (
    <Page
      title={t("title.mfa_settings")}
      secondaryTitle={t("title.mfa_settings_secondary")}
    >
      <Stack spacing={5}>
        {activeMfaMethodsMarkup}
        {/* {credentialsSectionMarkup} */}
      </Stack>
    </Page>
  );
};
